export interface ChannelTrackData {
  index: number
  lang: string
  data: any
  flags: string[]
}

export interface CurrentChannelData {
  audioTracks: ChannelTrackData[]
  subtitleTracks: ChannelTrackData[]
  isSubtitleEnabled: boolean
  currentAudioTrack?: ChannelTrackData
  currentSubtitleTrack?: ChannelTrackData
}

export enum ChannelTrackDataFlags {
  HEARING_IMPAIRED = 'HEARING_IMPAIRED',
  VISUAL_IMPAIRED = 'VISUAL_IMPAIRED',
}
